<!--Title Section-->
<app-title-jumbo title="White Papers" comment="Authoritative reports that inform concisely about Factor Investing and present a specific aspect of this matter's philosophy"></app-title-jumbo>

<div class="my-container">

  <section>
    <div class="container">
      <div class="offset-1 col-10">

        <!-- All deck -->
        <div *ngFor="let component of papersList;" class="card-deck">
          <div class="card mb-4">
            <!--Card header-->
            <div class="card-header">
              <div class="media">
                <div class="media-body">
                  <h3 class="card-text" style="color: rgb(118,168,255)">{{component.subject}}</h3>
                  <h3 style="text-align: center;">{{component.title}}</h3>
                  <p class="card-title">{{component.author}}</p>
                </div>
                <img class="d-flex ml-3" src="assets/img/roncalli.jpeg" alt="author" width="75">
              </div>
            </div>

            <!--Card content-->
            <div class="card-body">
              <p class="card-text">Abstract</p>
              <p class="card-text">{{component.abstract}}</p>
              <div class="row">
                <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Learn more</app-line-button>
                      </span>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!-- Card deck -->

      </div>
    </div>
  </section>

</div>
